import { FC, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import useAuth from "@hooks/useAuth";
import usePermissions from "@hooks/usePermissions";

import { IdleContextProvider } from "@contexts/Idle";

import { PageLayout } from "@components/PageLayout";
import { JivoChat } from "@components/JivoChat";
import { AcceptTermosModal } from "@components/AcceptTermsModal";
import { featureFlags } from "@settings";

export const PageLayoutProtected: FC = () => {
  const { user } = useAuth();
  const { allowedRoutes, loading, acceptedTerms } = usePermissions();
  const [modalTermsOpen, setModalTermsOpen] = useState<boolean>(
    () => !acceptedTerms,
  );

  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  } else if (loading) {
    return null;
  } else if (user.enableFaceMatch && !user.isChecked) {
    return <Navigate to="/validacao" replace />;
  } else {
    const matchingRoute = allowedRoutes.find((key) =>
      location.pathname.startsWith(key),
    );

    if (!matchingRoute) {
      return <Navigate to="/sem-acesso" replace />;
    }
  }

  return (
    <IdleContextProvider>
      <PageLayout showSider showHeader />
      {user.supportChat && <JivoChat />}
      {!acceptedTerms && featureFlags.enableAcceptTermsCef && (
        <AcceptTermosModal
          open={modalTermsOpen}
          onClose={() => setModalTermsOpen(false)}
        />
      )}
    </IdleContextProvider>
  );
};
